import { Language } from 'src/easyclaim.api.client.typescript/src/models/Language';
import styled from 'styled-components';

export interface FlagIconProps {
	flagCountryCode: string;
	className?: string;
}
export const FlagIcon = ({ flagCountryCode, className }: FlagIconProps) => {
	const isSupportedLanguage = Object.values(Language).some(
		(language) => language.toLowerCase() === flagCountryCode.toLowerCase()
	);
	const resolvedFlagCountryCode = isSupportedLanguage ? flagCountryCode : 'gb';

	return <FlagSpan className={`flag-icon flag-icon-${resolvedFlagCountryCode} ${className}`} />;
};

const FlagSpan = styled.span`
	font-size: 2rem;
`;
